module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#close",
      toString: function () {
        return this.url;
      }
    }